module.exports = __webpack_public_path__ + "assets/img/shu_11.4f4aa47d.png";